module.exports = __webpack_public_path__ + "img/znzs-1-sm.d2d08062.jpg";